module.exports = __webpack_public_path__ + "img/contributionBlue.e8ddf47c.png";